import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new5",
  "use": "new5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"new5\"><defs><style>#new5 .cls-1{fill:none}</style></defs><title>Group 148</title><g id=\"new5_图层_2\" data-name=\"图层 2\"><g id=\"new5_图层_1-2\" data-name=\"图层 1\"><g id=\"new5_Group_148\" data-name=\"Group 148\"><path id=\"new5_Rectangle_45_Copy_13\" data-name=\"Rectangle 45 Copy 13\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"new5_bells\"><path id=\"new5_Shape\" d=\"M10.31 22.31v-1.12H3.84a.85.85 0 1 1 0-1.69h.66V9a7.49 7.49 0 0 1 6.66-7.45v-.7a.84.84 0 1 1 1.68 0v.7A7.49 7.49 0 0 1 19.5 9v10.5h.66a.85.85 0 0 1 0 1.69h-6.47v1.12a1.69 1.69 0 0 1-3.38 0z\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new5.svg
// module id = LhBq
// module chunks = 6